const edrDataSources = ['Well Seeker', 'Well Seeker Client', 'WITSML', 'Vantage Data Link', 'NOV Welldata']
const surveyDataSources = ['Well Seeker', 'Survey Correction Provider', 'WITSML', 'NOV Welldata', 'DD Provider']
const bhaDataSources = ['Well Seeker', 'DD Provider', 'WellView', 'WellEz']
const dailyReportDataSources = ['Well Seeker', 'DD Provider', 'Auto from EDR Data', 'WellView', 'WellEz']
const slideSheetDataSources = ['Well Seeker', 'DD Provider', 'Auto from EDR Data']
const costDataSources = ['Well Seeker', 'DD Provider', 'WellView', 'WellEz']
const formationsDataSources = ['Well Seeker', 'StarSteer', 'ZoneVu']
const targetLinesDataSources = ['Well Seeker', 'StarSteer']
const wellPlansDataSources = ['Well Seeker', 'DD Provider', 'BHI Via Databridge']

const DataConfigDefaultParamDefinitions = (unitsList, organization, errorModelHeaders = []) => [
  {
    group: 'defaultDataSources',
    tag: 'edr',
    label: 'EDR Source',
    type: 'dropDown',
    dropDownOptions: edrDataSources,
  },
  {
    group: 'defaultDataSources',
    tag: 'defaultUnitSet',
    label: 'EDR units',
    type: 'dropDown',
    dropDownOptions: Array.isArray(unitsList)
      ? unitsList
          .map((unit) => (unit.organization === organization ? { label: unit.label, value: unit.label } : null))
          .filter(Boolean)
      : [],
  },
  {
    group: 'defaultDataSources',
    tag: 'bha',
    label: 'BHA',
    type: 'dropDown',
    dropDownOptions: bhaDataSources,
  },
  {
    group: 'defaultDataSources',
    tag: 'dailyReports',
    label: 'Daily Reports',
    type: 'dropDown',
    dropDownOptions: dailyReportDataSources,
  },
  {
    group: 'defaultDataSources',
    tag: 'slideSheets',
    label: 'Slide Sheets',
    type: 'dropDown',
    dropDownOptions: slideSheetDataSources,
  },
  {
    group: 'defaultDataSources',
    tag: 'costs',
    label: 'Costs',
    type: 'dropDown',
    dropDownOptions: costDataSources,
  },
  {
    group: 'defaultDataSources',
    tag: 'formations',
    label: 'Formations',
    type: 'dropDown',
    dropDownOptions: formationsDataSources,
  },
  {
    group: 'defaultDataSources',
    tag: 'surveys',
    label: 'Surveys',
    type: 'dropDown',
    dropDownOptions: surveyDataSources,
  },
  {
    group: 'defaultDataSources',
    tag: 'targetLines',
    label: 'Target Lines',
    type: 'dropDown',
    dropDownOptions: targetLinesDataSources,
  },
  {
    group: 'defaultDataSources',
    tag: 'wellPlans',
    label: 'Well Plans',
    type: 'dropDown',
    dropDownOptions: wellPlansDataSources,
  },
  {
    group: 'defaultDataSources',
    tag: 'defaultIpm',
    label: 'Default IPM',
    type: 'dropDownWithSearch',
    dropDownOptions: Array.isArray(errorModelHeaders)
      ? errorModelHeaders.map((header) => ({ label: header.fileName, value: header.fileName }))
      : [],
  },
  {
    group: 'defaultDataSources',
    tag: 'createWellFromDbAccess',
    label: 'Create Well DD Vendor',
    type: 'boolean',
  },
  {
    group: 'defaultDataSources',
    tag: 'useEdrWellStatus',
    label: 'Use EDR Well Status',
    type: 'boolean',
  },
  {
    group: 'autoCreateOptions',
    tag: 'autoPullPrincipalPlan',
    label: 'Pull Principal Plan',
    type: 'boolean',
  },
  {
    group: 'autoCreateOptions',
    tag: 'autoPullOffsets',
    label: 'Pull Offsets',
    type: 'boolean',
  },
]

function buildDefinitionsForGroup(group, defaultDataConfig, unitsList = [], organization, errorModelHeaders = []) {
  if (!defaultDataConfig || typeof defaultDataConfig !== 'object') return []
  const cfgDefs = DataConfigDefaultParamDefinitions(unitsList, organization, errorModelHeaders)
  const defs = cfgDefs.filter((def) => def.group === group)
  return defs.map((field, index) => {
    let value =
      defaultDataConfig[field.tag] === undefined || defaultDataConfig[field.tag] === null
        ? ''
        : defaultDataConfig[field.tag]

    if (field.section) {
      value = defaultDataConfig[field.section] ? defaultDataConfig[field.section][field.tag] : ''

      if (field.subSection && defaultDataConfig[field.section]) {
        value = defaultDataConfig[field.section][field.subSection]
          ? defaultDataConfig[field.section][field.subSection][field.tag]
          : ''
      }
    }

    if (field.valueGetter) {
      value = field.valueGetter(defaultDataConfig)
    }

    return { ...field, id: index, value: value }
  })
}

export function getDefaultDataSources(dataConfig, unitsList, organization, errorModelHeaders) {
  return buildDefinitionsForGroup('defaultDataSources', dataConfig, unitsList, organization, errorModelHeaders)
}

export function getAutoCreateOptions(dataConfig, unitsList, organization, errorModelHeaders) {
  return buildDefinitionsForGroup('autoCreateOptions', dataConfig, unitsList, organization, errorModelHeaders)
}

export default DataConfigDefaultParamDefinitions
